import update from 'immutability-helper';
import {
  GET_WORSHIP_LOCATIONS_SUCCESS,
  GET_WORSHIP_LOCATION_BY_ID_SUCCESS,
  RESET_WORSHIP_LOCATION_BY_ID_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
  worshipLocationsList: [],
  currentWorshipLocation: '',
};

const communities = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORSHIP_LOCATIONS_SUCCESS:
      return update(state, {
        worshipLocationsList: {
          $set: action.payload.worshipLocations,
        },
      });
    case GET_WORSHIP_LOCATION_BY_ID_SUCCESS:
      return update(state, {
        currentWorshipLocation: {
          $set: action.payload.worshipLocation,
        },
      });
    case RESET_WORSHIP_LOCATION_BY_ID_SUCCESS:
      return update(state, {
        currentWorshipLocation: {
          $set: '',
        },
      });
    default:
      return state;
  }
};

export default communities;
